import React, { useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function OrderConfirmation() {
  const { id } = useParams();
  const navigate = useNavigate();

  // Guard: if the user presses Back, don't let them return to checkout —
  // keep them on this confirmation screen.
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const onPop = () => { window.history.pushState(null, "", window.location.href); };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  return (
    <main className="sq-container py-24 flex items-center justify-center" data-testid="order-confirmation">
      <div className="max-w-lg w-full text-center">
        <div className="flex justify-center mb-6">
          <CheckCircle2 size={72} className="text-green-500" strokeWidth={1.5} />
        </div>
        <div className="sq-eyebrow text-squire-jeans">Payment Successful</div>
        <h1 className="font-display text-4xl md:text-5xl mt-3">Order Confirmed</h1>
        <p className="text-[#4B5563] mt-4">
          Thank you — your order{id ? <> <span className="font-medium text-black">#{id}</span></> : ""} has been placed successfully. A confirmation has been saved to your account.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-10">
          <button
            data-testid="confirm-see-status"
            onClick={() => navigate(id ? `/track-order?id=${id}` : "/orders", { replace: true })}
            className="sq-btn-primary"
          >
            See Order Status
          </button>
          <button
            data-testid="confirm-continue-shop"
            onClick={() => navigate("/", { replace: true })}
            className="sq-btn-outline"
          >
            Continue to Shop
          </button>
        </div>
      </div>
    </main>
  );
}
